export const recommendedLessonsClassNames = {
  root: 'academy-recommended-lessons',
  grid: 'academy-recommended-lessons-grid',
  card: 'academy-recommended-lesson-card',
};
